import React, { useRef , useContext, useEffect } from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';
import {Context} from "../../../store/reducer";
import { Radar } from "react-chartjs-2";
import '../../../assets/css/vis_95_1_style.css';

/**
 * 95_1 徒歩圏内の施設充実度のポップアップ
 *
 * @param spot
 * @param latitude
 * @param longitude
 * @param menu
 * @param draggable
 * @param option
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({id, latitude, longitude, polygonProperties, closePopup}) => {

  const { state } = useContext(Context);
  const markerRef = useRef(null);
  
  useEffect(() => {
    
    // 変化があるごとにポップアップを自動表示
    if (markerRef.current) {
      markerRef.current.openPopup();
    }
  });
  
  const icon = menu2icon["vis_32"]

  const iconUrl = new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [17, 23],
    popupAnchor: [0, -50]
  });

  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handlePopupClose = () => {
    if (markerRef.current) {
      // Leafletのマーカーポップアップを閉じる
      // markerRef.current.closePopup();
    }

    closePopup();
  }
  
  const handleSpotData = (polygonProperties) => {
    let ret = [];

    // レーダーチャート用のラベルとデータを個別に記載
    const labels = [
        'スーパーマーケット',
        'コンビニ',
        '郵便局',
        'ドラッグストア',
        'クリーニング',
        '医療施設',
        '公園',
        '交番',
        '飲食店',
        'カフェ',
        '弁当・惣菜',
        'パン',
        '大型商業施設',
        '習い事教室',
        '子育て施設'
    ];

    const data = [
        polygonProperties['01_RA_A001_SM'] || 0, // スーパーマーケットスコア
        polygonProperties['01_RA_A002_CVS'] || 0, // コンビニスコア
        polygonProperties['01_RA_A003_PO'] || 0, // 郵便局スコア
        polygonProperties['01_RA_A004_DRG'] || 0, // ドラッグストアスコア
        polygonProperties['01_RA_A005_Cleaning'] || 0, // クリーニングスコア
        polygonProperties['01_RA_A006_Medical'] || 0, // 医療施設スコア
        polygonProperties['01_RA_A007_Park'] || 0, // 公園スコア
        polygonProperties['01_RA_A008_Police'] || 0, // 交番スコア
        polygonProperties['01_RA_A010_Restaurant'] || 0, // 飲食店スコア
        polygonProperties['01_RA_A011_Cafe'] || 0, // カフェスコア
        polygonProperties['01_RA_A012_Bento'] || 0, // 弁当・惣菜スコア
        polygonProperties['01_RA_A013_Bakery'] || 0, // パンスコア
        polygonProperties['01_RA_A014_SC'] || 0, // 大型商業施設スコア
        polygonProperties['01_RA_A022_Lesson'] || 0, // 習い事教室スコア
        polygonProperties['01_RA_A026_School'] || 0 // 子育て施設スコア
    ];

    // レーダーチャートをhandleSpotDataメソッド内に移動
    ret.push(<h2 className="p-score-ttl">徒歩圏内の施設充実度</h2>)
    ret.push(<dl className="p-score">
      <dt>総合スコア</dt>
      <dd>{Math.round(polygonProperties["01_RA"])}</dd>
    </dl>)

    ret.push(
      <div>
        <Radar
          data={{
            labels: labels,
            datasets: [
              {
                label: 'データ',
                data: data,
                backgroundColor: 'rgba(255, 99, 132, 0.6)',
                borderColor: 'rgb(255, 99, 132)',
                borderWidth: 1,
              }
            ]
          }}
          options={{
            scales: {
              r: {
                min: 0,
                max: 100,
                beginAtZero: false,
                grid: {
                  display: true // 罫線
                }
              }
            },
            plugins: {
              legend: {
                display: false
              }
            }
          }}
        />
      </div>
    );

    return ret;
  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){


    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={iconUrl}
          ref={markerRef}
        >
          <Popup  
            autoPan={true}
            keepInView={true}    
            autoPanPadding={L.point(30, 70)}
            onClose={handlePopupClose}
          >
            {
              handleSpotData(polygonProperties)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
